import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { error: null, errorInfo: null };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo,
        });
    }
    render() {
        if (this.state.errorInfo) {
            return (_jsxs("div", { className: "error-boundary", children: [_jsx("h2", { className: "error-boundary__heading", children: "Noe gikk galt :(" }), _jsx("p", { className: "error-boundary__text", children: "Fortsetter problemet, vennligst kontakt support." }), _jsx("strong", { children: "Feilmelding:" }), _jsxs("div", { className: "error-boundary__details", children: [this.state.error && this.state.error.toString(), _jsx("br", {}), this.state.errorInfo.componentStack] })] }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
